module.exports = __webpack_public_path__ + "static/media/Logo-Horizontal.60a4c701.png";